/**
 * The parenthetical on a plan feature.
 *
 * `limit` of 0 is a real cap. Rendering it with `limit &&` prints the digit
 * straight after the name ("Messages0") and hides an included feature whose
 * limit is null, which is the unlimited case.
 */
export function planFeatureLimitLabel(feature: { included?: boolean | null; limit?: number | null }): string | null {
    if (!feature.included) return null;
    if (feature.limit === null || feature.limit === undefined) return "Unlimited";
    if (typeof feature.limit !== "number" || !Number.isFinite(feature.limit)) return null;
    return feature.limit.toLocaleString();
}
